module.exports = __webpack_public_path__ + "img/vcontroller-show-btn3-model.cb91a4a1.jpg";